/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import "react-dropzone-uploader/dist/styles.css";
import "./filtering.css";

import { Button, Modal } from "react-bootstrap";
import Dropzone from "react-dropzone-uploader";
import { axiosInstance } from "../../../../services/AxiosInstance";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <div>
      Search :{" "}
      <input
        type="search"
        className="ml-2 input-search form-control"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        style={{ width: "20%" }}
      />
    </div>
  );
};

export const User = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [qualificationshowModal, setqualificationShowModal] = useState(false);
  const [selectedqualification, setSelectedqualification] = useState(null);

  const qualificationopenModal = (qualification) => {
    setSelectedqualification(qualification);
    setqualificationShowModal(true);
  };

  const qualificationcloseModal = () => {
    setSelectedImage(null);
    setqualificationShowModal(false);
  };
  const openModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setShowModal(false);
  };
  const keys = [
    "id",
    "fname",
    "lname",
    "email",
    "country",
    "state",
    "city",
    "phone",
    "unique_id",
  ];
  const [data, setData] = useState([]);
  const [event, setEvent] = useState([]);
  const [eventkeys, setEventkeys] = useState([]);
  const [show, setShow] = useState(false);
  const onShow = () => setShow(true);
  const onHide = () => setShow(false);
  const [editshow, setEditShow] = useState(false);
  const onEditShow = () => setEditShow(true);
  const onEditHide = () => setEditShow(false);
  const [loader, setLoader] = useState(false);
  const [fieldValues, setFieldValues] = useState({});
  const [image, setImage] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [quill, setQuill] = useState("");
  const [stamping, setStamping] = useState("");
  const [information, setInformation] = useState("");
  const quillStyles = {
    border: `2px solid #000`, // Change the border color as desired
    borderRadius: "20px",
    height: "230px",
    overflow: "hidden",
    paddingBottom: "35px ",
  };
  // Define a function to handle the upload status
  const getUploadParams = ({ meta }) => {
    return { url: "https://httpbin.org/post" }; // Replace with your upload endpoint
  };

  // Define a function to handle the success of a file upload
  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === "done") {
      console.log("File uploaded:", file);
      setUploadedFiles([...uploadedFiles, file]); // Add the uploaded file to the state
    }
  };
  const handleProfileChange = ({ meta, file }, status) => {
    if (status === "done") {
      console.log("File uploaded:", file);
      setImage([...image, file]); // Add the uploaded file to the state
    }
  };
  const COLUMNS = [
    ...keys.map((key) => ({
      Header:
        key === "fname"
          ? "First Name"
          : key === "lname"
          ? "Last Name"
          : key === "unique_id"
          ? "unique Id"
          : key,
      Footer:
        key === "fname"
          ? "FirstName"
          : key === "lname"
          ? "LastName"
          : key === "unique_id"
          ? "unique Id"
          : key,
      accessor: key,
      Filter: ColumnFilter,
    })),

    {
      Header: "Profile Picture",
      Footer: "Profile Picture",
      accessor: "images",
      Cell: ({ value }) => {
        return (
          <>
            <img
              src={value[0]?.image}
              alt=""
              width={60}
              style={{ borderRadius: "50%" }}
              height={60}
            />
          </>
        );
      },
    },
    {
      Header: "status",
      Footer: "status",
      accessor: "status",
      Cell: ({ value, row }) => {
        const active = (id) => {
          setLoader(true);
          try {
            axiosInstance
              .put(`admin/users/${id}/activate`)
              .then((response) => {
                if (response.data.status === true) {
                  getUser();
                  toast.success(response.data.response);
                  setLoader(false);
                } else {
                  toast.success(response.data.error);
                  setLoader(false);
                }
              })
              .catch((errors) => {
                toast.error("SomeThing went Wrong");
                setLoader(false);
              });
          } catch (error) {
            toast.error(error);
          }
        };
        return (
          <>
            <button
              class={`badge ${value === 0 ? "bg-danger" : "bg-success"}`}
              onClick={() => active(row.original.id)}
            >
              {value === 0 ? "De-active" : "Active"}{" "}
            </button>
          </>
        );
      },
    },
    {
      Header: "Action",
      Footer: "Action",
      Cell: ({ row }) => {
        const Deleteuser = (id) => {
          setLoader(true);
          try {
            axiosInstance
              .delete(`admin/users/${id}`)
              .then((response) => {
                if (response.data === 1) {
                  getUser();
                  toast.success("Deleted");
                  setLoader(false);
                } else {
                  toast.error("SomeThing went Wrong");
                  setLoader(false);
                }
              })
              .catch((errors) => {
                toast.error("SomeThing went Wrong");
                setLoader(false);
              });
          } catch (error) {
            toast.error(error);
          }
        };
        return (
          <>
            <div className="d-flex ">
              <button
                onClick={() => {
                  onEditShow();
                  setEvent(row.original.id);
                }}
                title="Edit"
                className={`btn btn-outline-success btn-sm rounded`}
              >
                <i className="fa fa-pen" />
              </button>
              <button
                onClick={() => {
                  Deleteuser(row.original.id);
                }}
                title="Edit"
                className={`btn btn-outline-danger btn-sm rounded`}
              >
                <i className="fa fa-trash" />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const [columns] = useState(COLUMNS);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter, pageIndex } = state;

  const getUser = () => {
    setLoader(true);
    axiosInstance
      .get("admin/users")
      .then(function (response) {
        console.log(response, "Getting Compaines");
        if (response?.data.status === true) {
          setData(response?.data.data);
          const currentKeys = Object.keys(response?.data.data[0]);
          setEventkeys(currentKeys);
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  const adduser = () => {
    setLoader(true);
    var formdata = new FormData();
    eventkeys
      .filter(
        (s) =>
          s !== "id" &&
          s !== "created_at" &&
          s !== "updated_at" &&
          s !== "images" &&
          s !== "qualifications" &&
          s !== "reset_token" &&
          s !== "auth_token" &&
          s !== "access_token" &&
          s !== "status" &&
          s !== "education" &&
          s !== "item_information" &&
          s !== "city" &&
          s !== "country" &&
          s !== "state" &&
          s !== "education" &&
          s !== "item_information" &&
          s !== "item_stamping"
      )
      .map((e) => formdata.append(e, fieldValues[e]));
    formdata.append("country", selectedCountry?.name);
    formdata.append("city", selectedCity?.name);
    formdata.append("state", selectedState?.name);
    formdata.append("education", quill);
    formdata.append("item_information", information);
    formdata.append("item_stamping", stamping);
    image.map((e, i) => formdata.append(`images[${i}]`, e));
    uploadedFiles.map((e, i) => formdata.append(`qualifications[${i}]`, e));

    axiosInstance
      .post(`admin/users`, formdata)
      .then((response) => {
        if (response.data.status) {
          getUser();
          onHide();
          toast.success("Profile Updated Successfully!");
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const updateuser = () => {
    setLoader(true);
    var urlencoded = new URLSearchParams();
    eventkeys
      .filter(
        (s) =>
          s !== "id" &&
          s !== "created_at" &&
          s !== "updated_at" &&
          s !== "images" &&
          s !== "qualifications" &&
          s !== "reset_token" &&
          s !== "auth_token" &&
          s !== "access_token" &&
          s !== "status" &&
          s !== "item_information" &&
          s !== "education" &&
          s !== "state" &&
          s !== "city" &&
          s !== "country" &&
          s !== "item_stamping"
      )
      .map((e) =>
        data
          .filter((x) => x.id === event)
          .map((y) => {
            urlencoded.append(e, fieldValues[e] ? fieldValues[e] : y[e]);
            urlencoded.append(
              "country",
              selectedCountry?.name ? selectedCountry?.name : y["country"]
            );
            urlencoded.append(
              "city",
              selectedCity?.name ? selectedCity?.name : y["city"]
            );
            urlencoded.append(
              "state",
              selectedState?.name ? selectedState?.name : y["state"]
            );
            urlencoded.append("education", quill ? quill : y["education"]);
            urlencoded.append(
              "item_information",
              information ? information : y["item_information"]
            );
            urlencoded.append(
              "item_stamping",
              stamping ? stamping : y["item_stamping"]
            );
            return true;
          })
      );
    axiosInstance
      .put(`admin/users/${event}`, urlencoded)
      .then((response) => {
        if (response.data.status) {
          getUser();
          onEditHide();
          toast.success("Profile Updated Successfully!");
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const update_qualifications = (file) => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("qualifications[0]", file[0]);
    axiosInstance
      .post(`admin/users/${event}/qualifications`, formdata)
      .then((response) => {
        if (response.data.status) {
          getUser();
          onEditHide();
          toast.success("Qualifications update Successfully!");
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const update_images = (file) => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("images[0]", file[0]);
    axiosInstance
      .post(`admin/users/${event}/images`, formdata)
      .then((response) => {
        if (response.data.status) {
          getUser();
          onEditHide();
          toast.success("Image Upload Successfully!");
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const delete_images = (id) => {
    setLoader(true);
    const formdata = new FormData();
    axiosInstance
      .delete(`admin/users/images/${id}`, formdata)
      .then((response) => {
        if (response.data.status) {
          getUser();
          closeModal();
          onEditHide();
          toast.success("Picture Deleted Successfully!");
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const delete_qualification = (id) => {
    setLoader(true);
    const formdata = new FormData();
    axiosInstance
      .delete(`admin/users/qualifications/${id}`, formdata)
      .then((response) => {
        if (response.data.status) {
          getUser();
          onEditHide();
          qualificationcloseModal();
          toast.success("Qualifications Deleted Successfully!");
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  useEffect(() => {
    getUser();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  useEffect(() => {
    data.filter((x) => x.id === event).map((y) => setQuill(y["education"]));
    data
      .filter((x) => x.id === event)
      .map((y) => setInformation(y["item_information"]));
    data
      .filter((x) => x.id === event)
      .map((y) => setStamping(y["item_stamping"]));
  }, [event]);
  console.log(eventkeys, "eventkeys ");
  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="card">
        <div>
          <div className="card-header">
            <h4 className="card-title float-left">User Mangement</h4>
            <button className="btn btn-primary float-end" onClick={onShow}>
              Add User
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              id="table-to-export" // Add the id attribute
              className="table display"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* {column.canFilter ? column.render("Filter") : null} */}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between">
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
              {""}
            </span>
            <span className="table-index">
              Go to page :{" "}
              <input
                type="number"
                className="ml-2"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const pageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 0;
                  gotoPage(pageNumber);
                }}
              />
            </span>
          </div>
          <div className="text-center">
            <div className="filter-pagination  mt-3">
              <button
                className=" previous-button"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>

              <button
                className="previous-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Previous
              </button>
              <button
                className="next-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next
              </button>
              <button
                className=" next-button"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Add Modal */}
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>Add User</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {eventkeys
                .filter(
                  (s) =>
                    s !== "id" &&
                    s !== "created_at" &&
                    s !== "updated_at" &&
                    s !== "images" &&
                    s !== "qualifications" &&
                    s !== "reset_token" &&
                    s !== "auth_token" &&
                    s !== "access_token" &&
                    s !== "status" &&
                    s !== "password"
                )
                .sort((a, b) =>
                  a === "address" || a === "education"
                    ? 1
                    : b === "address" || b === "education"
                    ? -1
                    : 0
                )
                .map((e) => {
                  return (
                    <>
                      <div
                        className={`mb-3 ${
                          e === "education" ||
                          e === "address" ||
                          e === "item_information" ||
                          e === "item_stamping"
                            ? "col-md-12 col-sm-12"
                            : "col-md-6 col-sm-12"
                        }`}
                      >
                        <h5 className="text-capitalize">
                          {e === "dob"
                            ? "Date of Birth"
                            : e === "phone"
                            ? "Phone Number"
                            : e === "fname"
                            ? "First Name"
                            : e === "lname"
                            ? "Last Name"
                            : e === "unique_id"
                            ? "Unique Id"
                            : e === "data_inspected"
                            ? "Date Inspected"
                            : e.replace(/_/g, " ")}
                        </h5>
                        {e === "education" ? (
                          <ReactQuill
                            style={quillStyles}
                            theme="snow"
                            value={quill}
                            onChange={setQuill}
                          />
                        ) : e === "item_information" ? (
                          <ReactQuill
                            style={quillStyles}
                            theme="snow"
                            value={information}
                            onChange={setInformation}
                          />
                        ) : e === "item_stamping" ? (
                          <ReactQuill
                            style={quillStyles}
                            theme="snow"
                            value={stamping}
                            onChange={setStamping}
                          />
                        ) : e === "country" ? (
                          <Select
                            options={Country.getAllCountries()}
                            getOptionLabel={(options) => options["name"]}
                            getOptionValue={(options) => options["name"]}
                            onChange={(item) => {
                              setSelectedCountry(item);
                            }}
                          />
                        ) : e === "state" ? (
                          <Select
                            options={State?.getStatesOfCountry(
                              selectedCountry?.isoCode
                            )}
                            getOptionLabel={(option) => option["name"]}
                            getOptionValue={(option) => option["name"]}
                            onChange={(item) => {
                              setSelectedState(item);
                            }}
                          />
                        ) : e === "city" ? (
                          <Select
                            options={City.getCitiesOfState(
                              selectedState?.countryCode,
                              selectedState?.isoCode
                            )}
                            getOptionLabel={(option) => option["name"]}
                            getOptionValue={(option) => option["name"]}
                            onChange={(item) => {
                              setSelectedCity(item);
                            }}
                          />
                        ) : (
                          <input
                            type={
                              e === "dob"
                                ? "date"
                                : e === "phone"
                                ? "number"
                                : e === "password"
                                ? "password"
                                : "text"
                            }
                            name={e}
                            className="form-control"
                            onChange={handleInputChange}
                          />
                        )}
                      </div>
                    </>
                  );
                })}

              <div className="col-md-6">
                <h5 className="text-capitalize">Qualification</h5>
                <Dropzone
                  getUploadParams={getUploadParams}
                  onChangeStatus={handleChangeStatus}
                  accept="image/*"
                  maxFiles={3}
                  // inputContent="Drag and drop an image or click to select one"
                />
              </div>
              <div className="col-md-6">
                <h5 className="text-capitalize">Profile Pictures</h5>
                <Dropzone
                  getUploadParams={getUploadParams}
                  onChangeStatus={handleProfileChange}
                  accept="image/*"
                  maxFiles={6}
                  // inputContent="Drag and drop an image or click to select one"
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Close
          </Button>
          <Button variant="success" onClick={adduser}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Add Modal Close */}
      {/* Update Modal Start */}
      <Modal show={editshow} onHide={onEditHide} size="lg">
        <Modal.Header closeButton>User Details</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {eventkeys
                .filter(
                  (s) =>
                    s !== "id" &&
                    s !== "created_at" &&
                    s !== "updated_at" &&
                    s !== "images" &&
                    s !== "qualifications" &&
                    s !== "reset_token" &&
                    s !== "auth_token" &&
                    s !== "access_token" &&
                    s !== "status"
                )
                .sort((a, b) =>
                  a === "address" || a === "education"
                    ? 1
                    : b === "address" || b === "education"
                    ? -1
                    : 0
                )
                .map((e) => {
                  return (
                    <>
                      {data
                        .filter((x) => x.id === event)
                        .map((y) => {
                          return (
                            <>
                              <div
                                className={`mb-3 ${
                                  e === "education" ||
                                  e === "address" ||
                                  e === "item_information" ||
                                  e === "item_stamping"
                                    ? "col-md-12 col-sm-12"
                                    : "col-md-6 col-sm-12"
                                }`}
                              >
                                <h5 className="text-capitalize">
                                  {e === "dob"
                                    ? "Date of Birth"
                                    : e === "phone"
                                    ? "Phone Number"
                                    : e === "fname"
                                    ? "First Name"
                                    : e === "lname"
                                    ? "Last Name"
                                    : e === "unique_id"
                                    ? "Unique Id"
                                    : e.replace(/_/g, " ")}
                                </h5>
                                {e === "education" ? (
                                  <ReactQuill
                                    style={quillStyles}
                                    theme="snow"
                                    value={quill}
                                    onChange={setQuill}
                                  />
                                ) : e === "item_information" ? (
                                  <ReactQuill
                                    style={quillStyles}
                                    theme="snow"
                                    value={information}
                                    onChange={setInformation}
                                  />
                                ) : e === "item_stamping" ? (
                                  <ReactQuill
                                    style={quillStyles}
                                    theme="snow"
                                    value={stamping}
                                    onChange={setStamping}
                                  />
                                ) : e === "country" ? (
                                  <Select
                                    options={Country.getAllCountries()}
                                    getOptionLabel={(options) =>
                                      options["name"]
                                    }
                                    getOptionValue={(options) =>
                                      options["name"]
                                    }
                                    defaultValue={Country.getAllCountries().find(
                                      (option) => option.name === y[e]
                                    )}
                                    onChange={(item) => {
                                      setSelectedCountry(item);
                                    }}
                                  />
                                ) : e === "state" ? (
                                  <Select
                                    options={State?.getStatesOfCountry(
                                      selectedCountry?.isoCode
                                    )}
                                    getOptionLabel={(option) => option["name"]}
                                    getOptionValue={(option) => option["name"]}
                                    defaultValue={State?.getStatesOfCountry(
                                      selectedCountry?.isoCode
                                    )?.find((option) => option.name === y[e])}
                                    onChange={(item) => {
                                      setSelectedState(item);
                                    }}
                                  />
                                ) : e === "city" ? (
                                  <Select
                                    options={City.getCitiesOfState(
                                      selectedState?.countryCode,
                                      selectedState?.isoCode
                                    )}
                                    getOptionLabel={(option) => option["name"]}
                                    getOptionValue={(option) => option["name"]}
                                    defaultValue={City.getCitiesOfState(
                                      selectedState?.countryCode,
                                      selectedState?.isoCode
                                    ).find((option) => option.name === y[e])}
                                    onChange={(item) => {
                                      setSelectedCity(item);
                                    }}
                                  />
                                ) : (
                                  <input
                                    type={
                                      e === "dob"
                                        ? "date"
                                        : e === "phone"
                                        ? "number"
                                        : "text"
                                    }
                                    name={e}
                                    defaultValue={y[e]}
                                    className="form-control"
                                    onChange={handleInputChange}
                                  />
                                )}
                              </div>
                            </>
                          );
                        })}
                    </>
                  );
                })}

              <div className="col-md-6">
                <h5 className="text-capitalize">Qualification</h5>
                <input
                  type="file"
                  className="form-control p-2"
                  onChange={(e) => update_qualifications(e.target.files)}
                />
                <div className="row mt-3">
                  {data
                    .filter((x) => x.id === event)
                    .map((y) =>
                      y.qualifications.map((z) => (
                        <div className="col-md-3 position-relative">
                          <img
                            src={z.qualification}
                            alt={y.fname}
                            height={80}
                            className="img-rounded w-100 mb-3 c-pointer"
                            onClick={() => qualificationopenModal(z)}
                          />
                        </div>
                      ))
                    )}
                  <Modal
                    show={qualificationshowModal}
                    onHide={qualificationcloseModal}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Qualification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {selectedqualification && (
                        <img
                          src={selectedqualification.qualification}
                          alt={selectedqualification.id}
                          className="img-rounded w-100"
                        />
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={qualificationcloseModal}
                      >
                        Close
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() =>
                          delete_qualification(selectedqualification.id)
                        }
                      >
                        Delete
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
              <div className="col-md-6">
                <h5 className="text-capitalize">Profile Pictures</h5>

                <input
                  type="file"
                  className="form-control p-2"
                  onChange={(e) => update_images(e.target.files)}
                />

                <div className="row mt-3">
                  {data
                    .filter((x) => x.id === event)
                    .map((y) =>
                      y.images.map((z) => (
                        <div key={z.id} className="col-md-3 ">
                          <img
                            src={z.image}
                            alt={y.fname}
                            height={80}
                            style={{ borderRadius: "50%", cursor: "pointer" }}
                            className="img-rounded w-100 mb-3"
                            onClick={() => openModal(z)}
                          />
                        </div>
                      ))
                    )}

                  <Modal show={showModal} onHide={closeModal}>
                    <Modal.Header closeButton>
                      <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {selectedImage && (
                        <img
                          src={selectedImage.image}
                          alt={selectedImage.id}
                          className="img-rounded w-100"
                        />
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={closeModal}>
                        Close
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => delete_images(selectedImage.id)}
                      >
                        Delete
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onEditHide}>
            Close
          </Button>
          <Button variant="success" onClick={updateuser}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Update Modal Close */}
    </>
  );
};
export default User;
